import { configureStore } from '@reduxjs/toolkit';
import projReducer from './reducers/create-proj-reducer';
import dashboardReducer from './reducers/dashboard-reducer';
import findCompReducer from './reducers/find-comp-reducer';
import customUnitReducer from './reducers/create-unit-reducer';
import findUnitReducer from './reducers/find-unit-reducer';

const store = configureStore({
  reducer: {
    createProjReducer: projReducer,
    dashboardReducer,
    findCompReducer,
    customUnitReducer,
    findUnitReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
